// extracted by mini-css-extract-plugin
export var animationAbsolute = "_29-q";
export var animationRelative = "_29-p";
export var backdropBlur = "_29-0";
export var detailLabelCell = "_29-12";
export var detailTable = "_29-11";
export var detailValueCell = "_29-13";
export var docIconBox = "_29-1d";
export var docIconBoxMd = "_29-1f";
export var docIconBoxSm = "_29-1e";
export var docTypeRow = "_29-16";
export var docTypeRowInner = "_29-17";
export var dropdownMatchDatePicker = "_29-3";
export var evidenceCardContent = "_29-1c";
export var fileUploadSpin = "_29-j";
export var gorgiasOpenButton = "_29-15 _29-d";
export var gorgiasTicketCard = "_29-14";
export var heroModalFooterButton = "_29-18";
export var hiddenContainer = "_29-o";
export var iconPrimary = "_29-1g";
export var iconSecondary = "_29-1h";
export var iconTertiary = "_29-1i";
export var integrationCard = "_29-1";
export var integrationLogoBox = "_29-2";
export var mainColumnSticky = "_29-1b";
export var maxWidthContainer = "_29-19";
export var modalContentBody = "_29-a";
export var modalHeaderImage = "_29-5";
export var modalImageLabel = "_29-7";
export var modalImageOverlay = "_29-6";
export var modalImageSubtitle = "_29-9";
export var modalImageTitle = "_29-8";
export var modalImageWrapper = "_29-4";
export var modalStickyFooter = "_29-b";
export var removeButton = "_29-e";
export var sidebarColumn = "_29-1a";
export var spinner = "_29-i";
export var timelineLine = "_29-y";
export var timelineLineBlack = "_29-10 _29-y";
export var timelineLineGray = "_29-z _29-y";
export var timelineLineHeight = "_29-x";
export var tlDotActivate = "_29-u";
export var tlDotActivateAnim = "_29-t";
export var tlDotHide = "_29-s";
export var tlDotHideAnim = "_29-r";
export var tlLineActivate = "_29-w";
export var tlLineActivateAnim = "_29-v";
export var uploadHint = "_29-n";
export var uploadIconBox = "_29-k";
export var uploadLabel = "_29-m";
export var uploadText = "_29-l";
export var uploadZone = "_29-f";
export var uploadZoneCursorDefault = "_29-h";
export var uploadZoneCursorPointer = "_29-g";
export var uploadedFileRow = "_29-c";
export var viewButton = "_29-d";